<p-dialog 
    [(visible)]="visible" 
    [style]="{width: '90vw'}"
    [modal]="true" 
    header="Add Your Prediction Data"
    [closable]="true"
    [focusOnShow]="false"
    (onHide)="closeDialog()"
>
<ng-container *ngIf="predictionForm">
    <form [formGroup]="predictionForm" (ngSubmit)="onSubmit()">
        <div class="grid gap-4">
            <div *ngFor="let column of columnDefinitions" class="col-2"> 
                <label class="block mb-2" [for]="column.name">{{column.name}}</label>
                <ng-container [ngSwitch]="column.formControlName">
                    <!-- Dropdown Input -->
                    <p-dropdown *ngSwitchCase="'DropDownList'"
                        [options]="getDropdownOptions(column.name)"
                        formControlName="{{column.name}}"
                        class="w-full"
                        [style]="{'min-height': '2.5rem'}"
                        optionLabel="label"
                        [autoDisplayFirst]="false"
                        placeholder="Select {{column.name}}"
                    ></p-dropdown>
                    <input *ngSwitchCase="'InputBox'" pInputText [formControlName]="column.name" placeholder="Enter Text Input Only" />
                    <p-inputNumber *ngSwitchCase="'Number'"
                    [formControlName]="column.name" placeholder="Enter Number Input Only"></p-inputNumber>
                <p-inputNumber *ngSwitchCase="'Decimal'"
                [formControlName]="column.name" mode="decimal" placeholder="Enter Decimal Input Only" [minFractionDigits]="2" [maxFractionDigits]="12"></p-inputNumber>
                <p-calendar *ngSwitchCase="'DatePicker'" [formControlName]="column.name"
                    [showIcon]="true" [readonlyInput]="true"
                    [showButtonBar]="true" [placeholder]="'Please Select ' + column?.name" 
                    [appendTo]="'body'" [responsive]="true"
                    ></p-calendar>
                    <p-calendar 
                    *ngSwitchCase="'DateTimePicker'" 
                    [formControlName]="column.name"
                    [showIcon]="true" 
                    [readonlyInput]="true" 
                    [showButtonBar]="true" 
                    [placeholder]="'Please Select ' + column?.name" 
                    [showTime]="true" 
                    [hourFormat]="'12'"                                             
                    [appendTo]="'body'" [responsive]="true"
                    class="responsive-calendar">
                  </p-calendar>

                </ng-container>
                <div *ngIf="predictionForm.get(column.name)?.invalid && predictionForm.get(column.name)?.touched">
                    <small class="p-error" *ngIf="predictionForm.get(column.name)?.errors?.required">This field is required.</small>
                  </div>

            </div>
        </div>
        
        <div class="flex justify-content-end mt-4">
            <button pButton 
                label="Cancel" 
                class="p-button-text mr-2" 
                (click)="closeDialog()"
                type="button"
            ></button>
            <button pButton 
                label="Save" 
                type="submit"
                [disabled]="!predictionForm.valid || loading"
            >
                <i *ngIf="loading" class="pi pi-spinner pi-spin mr-2"></i>
                <!-- {{loading ? 'Saving...' : 'Save'}} -->
            </button>
        </div>
    </form>
</ng-container>
</p-dialog>